import React from 'react'
import { Row, Col } from 'antd'
import PropTypes from 'prop-types'
//Model

// Components
import ViewTable from '../../../Table/ViewTable'
// Columns
import columns from './column.js'

export default class HangMucDuAnDetail extends React.PureComponent {
  constructor() {
    super();
    this.state = {

    }
  }
  componentDidMount() {

  }

  addSttToItems = (items) => {
    if (!items) return [];
    let newItems = [];
    if (items) {
      newItems = items.map((item, index) => ({ ...item, stt: index + 1 }))
    }
    return newItems;
  };

  render() {
    const { dataSource } = this.props;

    return (
      <Row>
        <div className="mt-10" />
        <ViewTable
          bordered
          pagination={false}
          columns={columns()}
          dataSource={this.addSttToItems(dataSource)}
          
        />
      </Row>
    )
  }
}

HangMucDuAnDetail.propTypes = {
  dataSource: PropTypes.array.isRequired,
};